import React from 'react'
import { withRouter } from 'react-router'
import { view } from 'react-easy-state'
import { isMobile } from 'react-device-detect'
import { Icon, Button } from 'antd'

import QuestionView from 'components/pages/students/questions/show/QuestionView'

class QuestionDetails extends React.Component {

  toggleQuestionList = () => {
    const questionListSider = document.getElementById('questionListSider')

    questionListSider.classList.toggle('active')

  }

  goToSettingsPage = () => {
    this.props.history.push('/settings')
  }

  goToNextQuestion = (questionId) => {

    const { chapterId } = this.props.match.params

    this.props.history.push(`/chapters/${chapterId}/questions/${questionId}`)
  }

  render() {

    const { question } = this.props

    const mobileHeader = <React.Fragment>
      <div className="left-menu">
        <Button type="link" onClick={this.props.goBack}><Icon type="arrow-left" /></Button>
        <Button type="link" onClick={this.toggleQuestionList}><Icon type="unordered-list" /></Button>
        <Button type="link" onClick={this.goToSettingsPage}><Icon type="setting" /></Button>
      </div>
      <div className="right-menu">
        <Button type="link" onClick={this.goToNextQuestion}><Icon type="arrow-right" /></Button>
      </div>
    </React.Fragment>

    return (
      <div className="lecture-view">
        <div className="header">
          {
            isMobile ? mobileHeader : null
          }
        </div>
        <div className="lecture-content">
          <QuestionView question={question} />
        </div>
      </div>
    )
  }
}

export default withRouter(view(QuestionDetails))
